document.addEventListener('DOMContentLoaded', () => {
    const formWrapper = document.querySelector('.newsletter__form-wrapper');

    if (!formWrapper) {
        console.warn('[Newsletter] Form wrapper not found');
        return;
    }

    const submitButton = formWrapper.querySelector('button[type="button"]');
    const emailInput = formWrapper.querySelector('input[type="email"]');
    const toast = formWrapper.querySelector('[data-newsletter-toast]');
    const toastMessage = toast?.querySelector('.newsletter-toast__message');
    const checkmarkIcon = toast?.querySelector('.newsletter-toast__checkmark');
    const warningIcon = toast?.querySelector('.newsletter-toast__warning');

    if (!toast || !toastMessage || !checkmarkIcon || !warningIcon) return;

    let toastTimeout = null;
    let isSubmitting = false;

    function validateEmail(email) {
        if (!email || !email.trim()) {
            return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email.trim());
    }

    function hideToast() {
        if (!toast) return;

        if (toastTimeout) {
            clearTimeout(toastTimeout);
            toastTimeout = null;
        }

        toast.classList.remove('opacity-100', 'max-h-[200px]', 'flex');
        toast.classList.add('opacity-0', 'max-h-0', 'hidden');

        setTimeout(() => {
            toast.classList.add('overflow-hidden');
        }, 300);
    }

    function showToast(message, type) {
        if (!toast || !toastMessage) return;

        hideToast();

        setTimeout(() => {
            toastMessage.textContent = message;

            if (type === 'success') {
                toast.classList.remove('bg-[#FF48000F]', 'text-[#FF4800]', 'hidden');
                toast.classList.add('bg-[#D9FFF0]', 'text-[#006E43]', 'flex');
                checkmarkIcon.classList.remove('hidden');
                warningIcon.classList.add('hidden');
            } else {
                toast.classList.remove('bg-[#D9FFF0]', 'text-[#006E43]', 'flex');
                toast.classList.add('bg-[#FF48000F]', 'text-[#FF4800]', 'flex');
                checkmarkIcon.classList.add('hidden');
                warningIcon.classList.remove('hidden');
            }

            toast.classList.remove('opacity-0', 'max-h-0', 'overflow-hidden', 'hidden');
            toast.classList.add('opacity-100', 'max-h-[200px]', 'flex');

            toastTimeout = setTimeout(() => {
                hideToast();
            }, 4000);
        }, 50);
    }

    function setLoadingState(isLoading) {
        if (!submitButton) return;

        if (isLoading) {
            submitButton.disabled = true;
            submitButton.classList.add('opacity-50', 'cursor-not-allowed');
            submitButton.classList.remove('cursor-pointer');
            return;
        }
        submitButton.disabled = false;
        submitButton.classList.remove('opacity-50', 'cursor-not-allowed');
        submitButton.classList.add('cursor-pointer');
    }

    async function handleSubmit(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }

        if (isSubmitting || submitButton?.disabled) {
            return false;
        }

        const email = emailInput?.value?.trim();
        if (!email) {
            showToast('Please enter your email address.', 'error');
            return false;
        }

        if (!validateEmail(email)) {
            showToast('Please enter a valid email address.', 'error');
            return false;
        }

        isSubmitting = true;
        setLoadingState(true);

        const formData = new FormData();
        const inputs = formWrapper.querySelectorAll('input');
        inputs.forEach(input => {
            if (input.name) {
                formData.append(input.name, input.value);
            }
        });

        const endpoint = formWrapper.getAttribute('data-action') || '/contact';

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'text/html, application/xhtml+xml',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                redirect: 'manual',
            });

            if (response.type === 'opaqueredirect' || response.status === 302 || response.status === 303) {
                showToast('Boom. You\'re officially on the list!', 'success');
                if (emailInput) emailInput.value = '';
                setLoadingState(false);
                return;
            }

            const responseText = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(responseText, 'text/html');

            const errorElement = doc.querySelector('.errors, .form-error, [data-form-error], .error');

            if (errorElement || response.status >= 400) {
                let errorMessage = 'An error occurred. Please try again.';

                if (errorElement) {
                    const errorText = errorElement.textContent?.trim();
                    if (errorText) {
                        errorMessage = errorText;
                    }
                } else if (response.status === 429) {
                    errorMessage = 'Too many requests. Please wait a moment and try again.';
                } else if (response.status >= 400) {
                    errorMessage = `Error ${response.status}: ${response.statusText || 'Please try again.'}`;
                }

                showToast(errorMessage, 'error');
            } else {
                showToast('Thank you for subscribing!', 'success');
                if (emailInput) emailInput.value = '';
            }
        } catch (error) {
            console.error('Newsletter submission error:', error);

            if (error.message?.includes('429') || error.message?.includes('too many')) {
                showToast('Too many requests. Please wait a moment and try again.', 'error');
            } else {
                showToast('An error occurred. Please try again.', 'error');
            }
        } finally {
            isSubmitting = false;
            setLoadingState(false);
        }

        return false;
    }

    if (submitButton) {
        submitButton.addEventListener('click', handleSubmit);
    }

    if (emailInput) {
        emailInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                handleSubmit();
            }
        });

        emailInput.addEventListener('blur', () => {
            const email = emailInput.value.trim();
            if (email && !validateEmail(email)) {
                showToast('Please enter a valid email address.', 'error');
            }
        });

        emailInput.addEventListener('input', () => {
            const email = emailInput.value.trim();
            if (email && validateEmail(email)) {
                hideToast();
            }
        });
    }
});